/** Flip to `true` to re-enable Primary Contact inputs on Assessment details Edit. */
export const ASSESSMENT_PRIMARY_CONTACTS_EDITABLE = false;

/**
 * Whether Primary Contacts should render as editable inputs.
 * @param {boolean} isEditMode - form Edit mode (`updateActive`)
 * @param {{ editable?: boolean }} [options] - override for tests
 */
export function shouldShowAssessmentPrimaryContactInputs(
  isEditMode,
  { editable = ASSESSMENT_PRIMARY_CONTACTS_EDITABLE } = {}
) {
  return Boolean(isEditMode) && editable;
}

/**
 * Existing primary contacts from assessment details (what Save must keep while locked).
 */
export function primaryContactsPayloadFromDetails(vqaDetails) {
  return {
    providerName: vqaDetails?.provider?.provider_contact_name ?? null,
    providerEmail: vqaDetails?.provider?.provider_contact_email ?? null,
    providerPhone: vqaDetails?.provider?.provider_contact_phone ?? null,
    sponsors: vqaDetails?.vqa_request_sponsors || [],
  };
}

/**
 * Picks which primary-contact values go into the Save payload.
 * While locked, form edits are ignored in favor of existing details.
 */
export function pickPrimaryContactsForSubmit({
  formContacts,
  detailsContacts,
  editable = ASSESSMENT_PRIMARY_CONTACTS_EDITABLE,
}) {
  return editable ? formContacts : detailsContacts;
}
